import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {CurrencyModel} from '../../../../models/CurrencyModel';
import {FilterAbstractModel} from '../../../../models/FilterAbstractModel';

@Component({
  selector: 'app-currency-filter',
  templateUrl: './currency-filter.component.html',
  styleUrls: ['./currency-filter.component.scss']
})
export class CurrencyFilterComponent extends FilterAbstractModel implements OnInit, OnChanges, OnDestroy {

  listFilterCurrency: any[];
  optionSelected: any;

  @Input() currencyData: any;
  @Input() currencySelected: CurrencyModel;

  constructor() {
    super();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if ('currencyData' in changes) {
      this.listFilterCurrency = this.currencyData ? this.currencyData : [];
      this.optionSelected = null;
    }
    if (this.currencySelected) {
      this.optionSelected = this.currencySelected;
    }
  }

  ngOnDestroy(): void {
  }

  reset() {
    this.optionSelected = null;
  }

}
